







































































































import { Vue, Component, Inject, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";
import _ from "@/boot/lodash";

// Components
import UpmindUpgradeMessage from "@/components/app/admin/upmind/upgradeMessage.vue";

// Enums/Data
import { ContractStatusCodes } from "@/models/contracts";
import { LogoSize, LogoType } from "@/data/enums/logos";
import { OrgFeatureKeys } from "@/data/constants";

// Types
import {
  IProvisionConfigurationsProviderData,
  IProvisionConfigurationsProviderMethods
} from "@/models/providers/provisionConfigurations";
import { ILogo } from "@/models/logos";

@Component({
  components: {
    "provision-configuration-list-item": () =>
      import(
        "@/components/app/admin/provisioning/provisionConfigurationListItem.vue"
      )
  }
})
export default class ProvisionConfigurationsListing extends Vue {
  // Inject - Provision configurations data

  @Inject({ from: "provisionConfigurationsProviderData" })
  public readonly $provisionConfigurationsData!: () => IProvisionConfigurationsProviderData;

  public get $configurationsData() {
    return this.$provisionConfigurationsData();
  }

  // Inject - Provision configurations methods

  @Inject({ from: "provisionConfigurationsProviderMethods" })
  public readonly $configurationsMethods!: IProvisionConfigurationsProviderMethods;

  // Props

  @Prop({ default: null })
  public selectedConfigurations!: any;

  // Methods

  public hasImage(provider) {
    return provider?.logos?.length;
  }

  public providerLogoSrc(provider): ILogo["url"] | undefined {
    return _.get(
      _.find(provider?.logos, l => {
        if (l.type === LogoType.ICON && l.size === LogoSize.TWO_X) return true;
        return false;
      }),
      "url"
    );
  }

  public getActiveTotal(counters) {
    return _.get(
      _.find(counters, ["status_code", ContractStatusCodes.ACTIVE]),
      "count",
      0
    );
  }

  public getTotal(counters) {
    return _.sum(
      _.map(counters, filteredCounter => {
        return filteredCounter.count;
      })
    );
  }

  public getTooltipProps(counters) {
    return {
      class: "provisioned-toolip",
      type: "is-dark",
      multilined: true,
      label: _.map(
        counters,
        counter =>
          `• ${counter.count} ${(this.getTooltipStatusLabel(
            counter.status_code
          ) as string)
            .toString()
            .toLowerCase()}`
      ).join("\n")
    };
  }

  public getTooltipStatusLabel(status) {
    switch (status) {
      case ContractStatusCodes.ACTIVE:
        return this.$t("_.active");
      case ContractStatusCodes.AWAITING_ACTIVATION:
        return this.$t("_.subscription_awaiting_activation_summary");
      case ContractStatusCodes.PENDING:
        return this.$t("_.subscription_pending_summary");
      case ContractStatusCodes.SUSPENDED:
        return this.$t("_.suspended");
      case ContractStatusCodes.CANCELLED:
        return this.$t("_.cancelled");
      case ContractStatusCodes.CLOSED:
        return this.$t("_.lapsed");
      default:
        return "";
    }
  }

  public goToContractProducts(configuration, isActive = true) {
    this.$router.push({
      name: isActive ? "admin__activeSubscriptions" : "adminSubscriptionsList",
      query: {
        CPL: `1;10;-created_at;provision_configuration_id|=|${configuration.id}`
      }
    });
  }

  // Computed

  public get showEmptyState() {
    return (
      !this.$configurationsData.isLoading &&
      !this.$configurationsData.table.data.length
    );
  }

  public get showSkeletons() {
    return (
      this.$configurationsData.isLoading ||
      !this.$configurationsData.table.total
    );
  }

  public get skeletonSize() {
    const { data } = this.$configurationsData.table;
    if (data.length) return data.length;
    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get upmindUpgradeMessage() {
    return {
      render: (h: CreateElement) => {
        if (this.$configurationsData.isLoading) return;
        return h(UpmindUpgradeMessage, {
          class: "has-margin-bottom-100",
          props: {
            featureKey: OrgFeatureKeys.UNLIMITED_PROVISION_CONFIGURATIONS,
            total: this.$configurationsData.allCategoriesTotal
          }
        });
      }
    };
  }
}
